var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreelancer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 7.5,
    fill: "#FFE5E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 7.5,
    stroke: "#FFE5E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.125 18.125H22.5V10.625C22.5 10.1277 22.3025 9.65081 21.9508 9.29917C21.5992 8.94754 21.1223 8.75 20.625 8.75H9.375C8.87772 8.75 8.40081 8.94754 8.04917 9.29917C7.69754 9.65081 7.5 10.1277 7.5 10.625V18.125H6.875C6.70924 18.125 6.55027 18.1908 6.43306 18.3081C6.31585 18.4253 6.25 18.5842 6.25 18.75V20C6.25 20.4973 6.44754 20.9742 6.79917 21.3258C7.15081 21.6775 7.62772 21.875 8.125 21.875H21.875C22.3723 21.875 22.8492 21.6775 23.2008 21.3258C23.5525 20.9742 23.75 20.4973 23.75 20V18.75C23.75 18.5842 23.6842 18.4253 23.5669 18.3081C23.4497 18.1908 23.2908 18.125 23.125 18.125ZM8.75 10.625C8.75 10.4592 8.81585 10.3003 8.93306 10.1831C9.05027 10.0658 9.20924 10 9.375 10H20.625C20.7908 10 20.9497 10.0658 21.0669 10.1831C21.1842 10.3003 21.25 10.4592 21.25 10.625V18.125H8.75V10.625ZM22.5 20C22.5 20.1658 22.4342 20.3247 22.3169 20.4419C22.1997 20.5592 22.0408 20.625 21.875 20.625H8.125C7.95924 20.625 7.80027 20.5592 7.68306 20.4419C7.56585 20.3247 7.5 20.1658 7.5 20V19.375H22.5V20ZM16.875 11.875C16.875 12.0408 16.8092 12.1997 16.6919 12.3169C16.5747 12.4342 16.4158 12.5 16.25 12.5H13.75C13.5842 12.5 13.4253 12.4342 13.3081 12.3169C13.1908 12.1997 13.125 12.0408 13.125 11.875C13.125 11.7092 13.1908 11.5503 13.3081 11.4331C13.4253 11.3158 13.5842 11.25 13.75 11.25H16.25C16.4158 11.25 16.5747 11.3158 16.6919 11.4331C16.8092 11.5503 16.875 11.7092 16.875 11.875Z",
    fill: "#D32F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreelancer);
export default __webpack_public_path__ + "static/media/freelancer.6ad1fc447b4b2d7b1f9b8336417cb454.svg";
export { ForwardRef as ReactComponent };